<template>
  <div class="major">
    <div class="title">
      <p>Professional advantage</p>
      <h2>专业优势</h2>
    </div>
    <el-row :gutter="30">
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <div class="info">
          <img src="@/assets/images/img1.12.png" class="img">
          <div class="item">
            <p>因为专业，所以放心</p>
            <p>近三年申报成功率100%</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <div class="info">
          <img src="@/assets/images/img1.13.png" class="img">
          <div class="item">
            <p>因为专业，您的风险我们承担</p>
            <p>不成功，赔偿您的前期投入</p>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="30">
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <div class="info">
          <img src="@/assets/images/img1.14.png" class="img">
          <div class="item">
            <p>因为专业，您可获得更多资助</p>
            <p>合理配置，风险共担</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <div class="info">
          <img src="@/assets/images/img1.15.png" class="img">
          <div class="item">
            <p>因为专业，所以安心</p>
            <p>我们遵循有法可依，合理规范</p>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Major"
};
</script>

<style lang="scss" scoped>
.major {
  width: 1000px;
  margin: 0 auto;
  padding: 30px 50px;
  .title {
    text-align: center;
    p {
      color: #f7a527;
      text-transform: uppercase;
      letter-spacing: 2px;
      word-spacing: 10px;
      font-size: 12px;
      line-height: 20px;
    }
    h2 {
      color: #666666;
      letter-spacing: 10px;
      margin-top: 10px;
    }
  }
  .el-row {
    padding: 0;
  }
  .info {
    border: 1px solid #eeeeee;
    border-radius: 5px;
    height: 100px;
    margin: 50px 0 10px;
    display: flex;
    padding:10px 0;
    .img {
      width: 10%;
      height: 70%;;
      display: inline-block;
      margin: -30px 15px 20px;
    }
    .item {
      display: inline-block;
      color: #666;
      font-size: 16px;

      p {
        line-height: 30px;
        // white-space: normal;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .major {
    width: 100%;
    padding: 30px 0px;
    .el-row {
      margin-left: 0px !important;
      margin-right: 0px !important;
      padding:0 6px;
    }
    .el-col {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
    .info {
      height: 100%;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/technology/major.vue